import React, { SVGProps } from "react";

export const Camera: React.FC<SVGProps<SVGSVGElement>> = ({
  width,
  height,
  fill,
}) => {
  return (
    <svg
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.975 8.5C14.175 8.5 15.975 10.3 15.975 12.5C15.975 14.7 14.175 16.5 11.975 16.5C9.77498 16.5 7.97498 14.7 7.97498 12.5C7.97498 10.3 9.77498 8.5 11.975 8.5ZM11.975 7C8.92498 7 6.47498 9.45 6.47498 12.5C6.47498 15.55 8.92498 18 11.975 18C15.025 18 17.475 15.55 17.475 12.5C17.475 9.45 15.025 7 11.975 7Z"
        fill={fill}
      />
      <path
        d="M15.525 3.5L16.125 4.65L16.475 5.35C16.525 5.45 16.625 5.5 16.675 5.5H21.425V20.5H2.42499V5.5H7.17499C7.27499 5.5 7.375 5.45 7.375 5.35L7.72498 4.65L8.32495 3.5H15.525ZM16.325 2H7.625C7.525 2 7.42499 2.05 7.42499 2.15L6.47498 4H1.27496C1.12496 4 0.974976 4.15 0.974976 4.3V21.75C0.974976 21.9 1.12496 22.05 1.27496 22.05H22.725C22.875 22.05 23.025 21.9 23.025 21.75V4.3C23.025 4.15 22.875 4 22.725 4H17.475L16.525 2.15C16.525 2.05 16.425 2 16.325 2Z"
        fill={fill}
      />
    </svg>
  );
};
